export const SERVICES = [
  {
    icon: "🖥️",
    title: "SCADA / HMI",
    short: "Integrate single machine visibility or all facets of your manufacturing and control system.",
    desc: "Our SCADA (Supervisory Control and Data Acquisition) and HMI (Human Machine Interface) systems are the backbone of modern industrial automation. We design intuitive operator interfaces and powerful supervisory systems that give your team complete visibility and control over your entire manufacturing operation.",
    features: [
      "Real-time plant-wide monitoring dashboards",
      "Centralised remote process control",
      "Historical data logging & trend analysis",
      "Alarm management & escalation workflows",
      "OPC-UA / MQTT data connectivity",
      "Web-based & mobile HMI applications",
    ],
    tags: ["Studio 5000", "FactoryTalk Batch", "FT View Studio"],
    imgs: ["/69.jpeg", "/66.jpeg"],
    highlight: "360° operational visibility",
    time: "4–14 weeks",
    industries: ["Food & Bev", "Pharma", "Manufacturing", "Water Treatment"],
  },
  {
    icon: "⚡",
    title: "Panel Desigining & Wiring",
    short: "We specialize in designing and manufacturing high-quality electrical and automation control panels tailored to meet the specific requirements of industrial applications",
    desc: "Our panels are engineered to ensure reliability, safety, and efficient performance, while complying with industry standards and best practices. We work closely with our clients to understand their unique needs and deliver custom solutions that optimize their operations.",
    features: [
      "Custom PLC logic development (all platforms)",
      "Motor control centres & drive systems",
      "Control panel design, build & certification",
      "SQL database integration for data capture",
      "Fieldbus and industrial networking",
      "Safety system design (SIL, PLe compliance)",
    ],
    tags: ["EPLAN", "Auto CAD", "Pro Panel"],
    imgs: ["/70.jpeg", "/71.jpeg", "/72.jpeg"],
    highlight: "Multi-platform expertise",
    time: "3–12 weeks",
    industries: ["Automotive", "Mining", "Oil & Gas", "Utilities"],
  },
  {
    icon: "🏭",
    title: "System Automation",
    short: "Automate your entire facility or production line and integrate it with new or existing equipment.",
    desc: "System Automation is our flagship offering — transforming entire facilities through end-to-end automation design and deployment. We analyse your current workflows, identify inefficiencies, and engineer a complete automated ecosystem that seamlessly integrates new and legacy equipment.",
    features: [
      "Full facility automation audits & roadmaps",
      "Conveyor, robotic & palletising integration",
      "Legacy equipment retrofitting & modernisation",
      "ERP / MES system integration",
      "Batch & continuous process automation",
      "Turnkey project delivery & commissioning",
    ],
    tags: ["Turnkey", "MES", "ERP", "Robotics"],
    imgs: ["/gallery/67.jpeg", "/gallery/61.jpg", "/gallery/55.jpg"],
    highlight: "40%+ efficiency gains",
    time: "12–36 weeks",
    industries: ["FMCG", "Automotive", "Pharma", "Logistics"],
  },
  {
    icon: "🔧",
    title: "Maintenance & Repair",
    short: "Comprehensive upgrade, maintenance, and repair services to keep your control systems running.",
    desc: "Unplanned downtime is the enemy of profitability. Our Maintenance & Repair services are designed to keep your automation systems running at peak performance — with proactive strategies that prevent issues before they arise and rapid-response capabilities when emergencies occur.",
    features: [
      "24/7 remote monitoring & diagnostics",
      "Scheduled preventative maintenance programmes",
      "Emergency on-site breakdown response",
      "Obsolescence management & component sourcing",
      "System health reports & KPI dashboards",
      "Engineer training & knowledge transfer",
    ],
    tags: ["Predictive", "Remote", "24/7", "OEM Parts"],
    imgs: ["/gallery/38.jpg", "/gallery/33.jpg", "/gallery/34.jpg"],
    highlight: "60% less unplanned downtime",
    time: "Ongoing",
    industries: ["All Industries", "Critical Infrastructure"],
  }
  ,
  {
    icon: "📊",
    title: "Energy Management System",
    short: "Monitor, control, and optimise energy consumption across your entire facility in real time.",
    desc: "Our Energy Management Systems (EMS) help you gain complete visibility over your facility's energy usage — from individual machines to entire production lines. We design and deploy intelligent metering, monitoring, and control solutions that reduce energy costs, improve sustainability, and ensure regulatory compliance.",
    features: [
      "Real-time energy monitoring & sub-metering",
      "Power quality analysis & load balancing",
      "Automated demand response & peak shaving",
      "Energy dashboards & consumption reporting",
      "Integration with BMS, SCADA & PLC systems",
      "ISO 50001 compliance support",
    ],
    tags: ["EMS", "Sub-metering", "ISO 50001", "BMS"],
    imgs: ["/68.jpeg", "/73.jpeg", "/74.jpeg"],
    highlight: "Up to 30% energy cost savings",
    time: "6–16 weeks",
    industries: ["Manufacturing", "Energy", "Utilities", "Pharma"],
  },
  {
    icon: "💼",
    title: "Consultancy",
    short: "Expert guidance on automation strategy, technology selection, and digital transformation roadmaps.",
    desc: "Our Consultancy services help you make informed decisions about your automation journey. From initial feasibility studies and technology assessments to detailed project planning and ROI analysis — our experienced engineers work alongside your team to develop a clear, actionable roadmap for digital transformation.",
    features: [
      "Automation feasibility studies & gap analysis",
      "Technology selection & vendor evaluation",
      "Digital transformation roadmaps",
      "ROI analysis & cost-benefit modelling",
      "Compliance & standards advisory (IEC, ISO)",
      "Project management & implementation oversight",
    ],
    tags: ["Strategy", "Feasibility", "ROI", "Standards"],
    imgs: [
      "https://images.unsplash.com/photo-1581094481644-f2ab64522498?auto=format&fit=crop&w=900&q=80",
      "https://images.unsplash.com/photo-1659353589241-f450b33f908a?auto=format&fit=crop&w=900&q=80",
      "https://images.unsplash.com/photo-1742112125650-2773716e50f2?auto=format&fit=crop&w=900&q=80",
    ],
    highlight: "Clear roadmap, measurable ROI",
    time: "2–8 weeks",
    industries: ["All Industries", "Greenfield & Brownfield"],
  }
];

export const INDUSTRIES = [
  {
    icon: "🚗",
    name: "Automotive",
    desc: "Optimise production lines, reduce downtime, and improve worker safety through advanced automation in body welding, paint shops, final assembly, and logistics.",
    stats: ["35% cycle time reduction", "99.2% line efficiency", "Zero-accident cell design"],
  },
  {
    icon: "💊",
    name: "Pharmaceutical",
    desc: "Ensure batch consistency, regulatory compliance (FDA, GMP), and end-to-end traceability across manufacturing, packaging, and cold-chain distribution.",
    stats: ["100% batch traceability", "FDA 21 CFR compliance", "Automated LIMS integration"],
  },
  {
    icon: "🏗️",
    name: "Manufacturing",
    desc: "We provide comprehensive industrial solutions designed to improve efficiency, reliability, and performance across your plant operations.",
    stats: ["40% productivity boost", "Scrap rate < 0.5%", "Real-time OEE monitoring"],
  },
  {
    icon: "🥤",
    name: "Food & Beverage",
    desc: "Automate processing, filling, packaging, and distribution while maintaining the highest food safety standards — from HACCP compliance to hygienic design and washdown-rated equipment.",
    stats: ["HACCP compliant", "90% waste reduction", "Full cold-chain tracking"],
  },
  {
    icon: "⚡",
    name: "Energy & Utilities",
    desc: "Manage power generation, distribution, water treatment, and renewable energy assets with intelligent SCADA systems that maximise uptime and grid stability.",
    stats: ["99.9% system uptime", "25% energy savings", "Predictive grid management"],
  },
  {
    icon: "🚢",
    name: "Logistics & Warehousing",
    desc: "Deploy automated conveyor systems, AGVs, AS/RS, and WMS integrations to transform your warehouse into a high-speed, error-free fulfilment powerhouse.",
    stats: ["3x order throughput", "99.8% pick accuracy", "AGV fleet management"],
  },
];

export const STATS = [
  { n: 50, suf: "+", label: "Projects Delivered" },
  { n: 99,  suf: "%", label: "Client Satisfaction" },
  { n: 7,  suf: "+", label: "Years Experience" },
  { n: 5,  suf: "",  label: "Countries Served" },
  { n: 15,  suf: "+", label: "Expert Engineers" },
  { n: 24,  suf: "/7",label: "Support Available" },
];

export const STEPS = [
  { n: "01", t: "Discovery & Audit",    d: "We conduct an in-depth audit of your existing processes, systems, and goals — mapping every bottleneck and opportunity for automation improvement." },
  { n: "02", t: "Solution Design",      d: "Our engineers develop a bespoke automation architecture, including system schematics, software specs, panel layouts, and network diagrams." },
  { n: "03", t: "Build & Programme",    d: "We build and programme all hardware and software components — from control panels and PLC code to SCADA screens and robot programs — in-house." },
  { n: "04", t: "Factory Acceptance",   d: "Every system undergoes rigorous Factory Acceptance Testing (FAT) against your specifications before a single component reaches your site." },
  { n: "05", t: "Site Installation",    d: "Our commissioning team carries out a structured site installation and Site Acceptance Test (SAT), minimising disruption to your live production." },
  { n: "06", t: "Training & Handover",  d: "We deliver comprehensive operator and maintenance training, full technical documentation, and a 12-month warranty support programme." },
];

export const TEAM = [
  { name: "Krishan Kumar", role: "Director",           exp: "20+ years in Industrial Automation",                  av: "👨‍💼" },
  { name: "Dr. Rajni",     role: "Managing Director",  exp: "18+ years in Electronics, Electrical & Data Science", av: "👩‍💻" },
  { name: "Amit Pal",      role: "Design Lead",        exp: "10+ years in Electrical Design",                      av: "👨‍🔧" },
  { name: "Sumit Gulati",  role: "Project Manager",    exp: "5+ years in Project Management",                      av: "👨‍💼" },
];

export const TIMELINE = [
  { y: "2019", e: "Founded",              d: "Established in Bawana Industrial Area, New Delhi with a mission to deliver high-quality, cost-effective industrial automation solutions across India." },
  { y: "2020", e: "First Major Project",  d: "Delivered our first end-to-end SCADA and control panel system for a leading manufacturing client — setting the standard for all future projects." },
  { y: "2021", e: "Service Expansion",    d: "Expanded our service portfolio to include energy management systems, consultancy, and comprehensive maintenance & repair services." },
  { y: "2024", e: "50+ Projects",         d: "Crossed 50 delivered projects across manufacturing, pharma, food & beverage, and energy sectors — with a 99% client satisfaction rate." },
  { y: "2026", e: "Growing Strong",       d: "Continuing to grow with a dedicated team of expert engineers, serving clients across multiple industries and regions." },
];

export const FB_CHALLENGES = [
  { icon: "📋", t: "Regulatory Compliance", d: "Automation ensures all processes adhere to food safety standards and local regulations, making it easier to track and report compliance requirements." },
  { icon: "♻️", t: "Waste Reduction",       d: "Automated sorting and packaging systems help minimise waste, optimise resource usage, and reduce costs through efficient use of materials." },
  { icon: "🧼", t: "Improved Food Safety",  d: "Automation maintains consistent hygiene throughout production, reducing contamination risks and ensuring products are safe for consumption." },
  { icon: "📈", t: "Consumer Demand",       d: "Automation allows businesses to scale efficiently to meet rising demand for healthier, organic, and sustainably produced food products." },
];

export const PROJECTS = [
  {
    title: "Choco Stick Production Line",
    client: "Confidential",
    location: "Haryana",
    year: "2025",
    image: "🏭",
    desc: "We successfully executed the Choco Stick production line project in Rohtak, supporting the launch of a high-demand product in the Indian market.",
    scope: [
      "Complete PLC-based automation solution (Allen-Bradley)",
      "Control panel design and manufacturing",
      "System integration and commissioning",
    ],
    outcome: [
      "Smooth and efficient commissioning of the production line",
      "Reliable automation system ensuring consistent product output",
      "Supported Lotte in meeting high market demand with optimized operations",
    ],
    tags: ["PLC", "Allen-Bradley", "Panel Design", "Commissioning"],
  },
  {
    title: "ChocoPie Production Lines",
    client: "Confidential",
    location: "Haryana & Tamil Nadu",
    year: "2024 & 2026",
    image: "🍫",
    desc: "We commissioned 2 ChocoPie production lines in Rohtak & Chennai, expanding capacity for one of India's most popular snack brands.",
    scope: [
      "Automation of the ChocoPie production line",
      "PLC programming and system integration",
      "Panel Design & Fabrication",
      "Commissioning and testing",
    ],
    outcome: [
      "Successful expansion of production capacity",
      "Seamless integration with existing systems",
      "Improved process efficiency and reliability",
    ],
    tags: ["PLC", "Panel Fabrication", "System Integration"],
  },
  {
    title: "Chocolate Manufacturing Plant",
    client: "Confidential",
    location: "Rajasthan",
    year: "2023",
    image: "🏗️",
    desc: "We played a key role in establishing a chocolate manufacturing facility in Bhiwadi — automating the entire production process from scratch.",
    scope: [
      "Complete automation of the chocolate production process from scratch",
      "PLC programming and control system design",
      "Panel manufacturing and system commissioning",
    ],
    outcome: [
      "Fully automated chocolate manufacturing setup",
      "Reliable and scalable system for future expansion",
      "End-to-end process control ensuring product consistency",
    ],
    tags: ["Greenfield", "PLC", "Panel Manufacturing"],
  },
  {
    title: "Chocolate Handling System — Magnum Ice Cream",
    client: "Confidential",
    location: "Maharashtra",
    year: "2024",
    image: "🍦",
    desc: "We automated the chocolate handling system used in Magnum ice cream production at Nashik, covering melting, storage, and transfer systems.",
    scope: [
      "Automation of melting, storage, and transfer systems",
      "PLC-based control system implementation",
      "Commissioning and system validation",
    ],
    outcome: [
      "Efficient and hygienic chocolate handling process",
      "Improved production reliability",
      "Consistent quality in end product",
    ],
    tags: ["PLC", "Food-Grade", "Hygienic Design"],
  },
  {
    title: "Vicks Production Line",
    client: "Confidential",
    location: "Gujarat",
    year: "2026",
    image: "💊",
    desc: "We successfully commissioned the Vicks production line in Sanand, delivering reliable automation that ensures uninterrupted production.",
    scope: [
      "Automation and commissioning of production line",
      "PLC system implementation",
      "On-site testing and validation",
    ],
    outcome: [
      "Smooth and timely project execution",
      "Reliable automation ensuring uninterrupted production",
      "Compliance with industry standards",
    ],
    tags: ["PLC", "Pharma", "Commissioning"],
  },
  {
    title: "Aseptic Fruit Processing Technology",
    client: "SNL",
    location: "Rajasthan",
    year: "2024",
    image: "🍊",
    desc: "We delivered automation and panel solutions for Mobile Aseptic Fruit Processing Technology at SNL, Jaipur — improving handling, filling, and storage of fruit pulp while enhancing product shelf life.",
    scope: [
      "Design & fabrication of electrical panels",
      "Automation system for fruit pulp filling, transfer & storage",
      "PLC & control integration for process flow management",
    ],
    outcome: [
      "Accurate and consistent process operations",
      "Enhanced product shelf life through aseptic technology",
      "Reliable and safe plant operations",
    ],
    tags: ["Panel Design", "PLC", "Aseptic", "Food Processing"],
  },
  {
    title: "Wheat Flour Conveying System Automation",
    client: "Kerry",
    location: "Haryana",
    year: "2024",
    image: "🌾",
    desc: "We delivered an automation solution for the wheat flour conveying system at Kerry's Bawal facility, ensuring efficient and controlled transfer of material across the plant.",
    scope: [
      "Automation of conveying system — bulker to hopper",
      "PLC-based control system with interlocks & sequencing",
      "Integration of sensors, motors & conveying equipment",
    ],
    outcome: [
      "Accurate material movement and process control",
      "Smooth and safe conveying operations",
      "Efficient plant-wide material transfer",
    ],
    tags: ["PLC", "Conveying", "System Integration"],
  },
  {
    title: "Energy Management System",
    client: "JSL",
    location: "Haryana",
    year: "2024",
    image: "⚡",
    desc: "We implemented an Energy Management System (EMS) for JSL Hisar, enabling real-time monitoring, analysis, and optimization of plant energy consumption.",
    scope: [
      "Panel design & supply for centralized energy data acquisition",
      "Integration of multifunction energy meters across plant sections",
      "Data acquisition, communication & real-time monitoring",
      "SCADA development for energy visualization & reporting",
    ],
    outcome: [
      "Real-time visibility of energy parameters across the plant",
      "Centralized monitoring of power consumption by area",
      "User-friendly SCADA interface for energy management",
    ],
    tags: ["EMS", "SCADA", "Metering", "Panel Design"],
  },
  {
    title: "Car Crash Testing Control Panel",
    client: "Tata Motors",
    location: "Maharashtra",
    year: "2024",
    image: "🚗",
    desc: "We designed and delivered a specialized control panel system for car crash testing applications at Tata Motors, Pune — enabling accurate measurement and monitoring of critical test parameters.",
    scope: [
      "Control panel design & engineering for crash test scenarios",
      "Integration of sensors & instrumentation for crash data capture",
      "Signal processing & high-speed data handling",
    ],
    outcome: [
      "Accurate acquisition of critical crash test data",
      "Reliable operation during high-speed test scenarios",
      "Efficient transmission of data for further analysis",
    ],
    tags: ["Panel Design", "Instrumentation", "Automotive", "Testing"],
  },
];

export const PAGES = ["Home", "About", "Services", "Industries", "Projects", "Contact"];

export const GALLERY_IMAGES = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 19, 20,
  21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 37, 38,
  39, 40, 41, 42, 43, 44, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56,
  58, 59, 61, 62, 63, 64, 65,
].map((n) => `/gallery/${n}.jpg`).concat(["66.jpeg", "67.jpeg", "68.jpeg", "69.jpeg", "70.jpeg", "71.jpeg", "72.jpeg", "73.jpeg", "74.jpeg"].map((n) => `/gallery/${n}`));
